import getCookie from "helpers/getCookie";

const getAuthTokenFromStorage = (): string | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage?.getItem("user_auth_token") || null;
  } catch (e) {
    // localStorage can throw (private mode / disabled storage) — treat as absent.
    return null;
  }
};

const hasAuthToken = (): boolean =>
  Boolean(
    getCookie("user_auth_token") || getAuthTokenFromStorage() || getCookie("user_flow_token"),
  );

export default hasAuthToken;
